import { modules } from "byzantine";
import { useBreakpoints } from "@narmi/design_system";

import CustomizationDialog from "./components/CustomizationDialog";
import { DashboardCustomizationProvider } from "./DashboardCustomizationContext";
import DashboardButton from "./components/DashboardButton";
import type { DashboardCustomizationProps } from "./types";

const { useIsDashboardCustomizationEnabled } = modules.userDisplayPreferences;

const DashboardCustomization = ({
  externalAccounts,
  servicesApps,
}: DashboardCustomizationProps) => {
  const { l } = useBreakpoints();
  const { isDashboardCustomizationEnabled } =
    useIsDashboardCustomizationEnabled();

  // hide if flag off or not on desktop
  if (!isDashboardCustomizationEnabled || !l) {
    return null;
  }

  return (
    <DashboardCustomizationProvider
      externalAccounts={externalAccounts}
      servicesApps={servicesApps}
    >
      <DashboardButton />
      <CustomizationDialog />
    </DashboardCustomizationProvider>
  );
};

export default DashboardCustomization;
